import React from 'react'
import { Link } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'
import { useBreadcrumbs, BreadcrumbItem } from '@/contexts/BreadcrumbContext'

interface BreadcrumbProps {
  className?: string
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ className = '' }) => {
  const { breadcrumbs } = useBreadcrumbs()

  if (breadcrumbs.length <= 1) {
    return null
  }

  return (
    <nav className={`flex items-center space-x-1 text-sm text-muted-foreground ${className}`} aria-label="Breadcrumb">
      <Link 
        to="/" 
        className="flex items-center hover:text-foreground transition-colors"
        title="Dashboard"
      >
        <Home className="h-4 w-4" />
      </Link>
      
      {breadcrumbs.slice(1).map((item: BreadcrumbItem, index: number) => (
        <React.Fragment key={item.path}>
          <ChevronRight className="h-4 w-4 text-muted-foreground/50" />
          {item.isActive ? (
            <span className="text-foreground font-medium" aria-current="page">
              {item.label}
            </span>
          ) : (
            <Link 
              to={item.path}
              className="hover:text-foreground transition-colors"
            >
              {item.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  )
}

export default Breadcrumb
